export default "__VITE_ASSET__a0947822__"